module.exports = __webpack_public_path__ + "d6413ba1/img/file-icon.c085e21e.svg";